<a class='button' [class.primary]='primary' [class.compact]='compact' [class.fullwidth]='fullwidth' [class]='"kind-" + kind' [href]='action' target='_blank' [attr.aria-label]='label' (click)='onclick()'>
    <span class='icon'></span>
    <span class='label' *ngIf='kind === "url"'>{{display}}</span>
    <span class='label' *ngIf='kind === "nav"'>{{display}}</span>
    <span class='label' *ngIf='kind === "phone"'>{{display}}</span>
    <span class='label' *ngIf='kind === "email"'>{{display}}</span>
</a>
<a class='copy' clickOnReturn (activated)='doCopy()' *ngIf='fullwidth'>
</a>